var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{attrs:{"id":"nav"}},[_c('Header'),_c('Menu'),_c('div',{staticClass:"container"},[_c('Gallery')],1),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }